import React, { useState, useEffect, useRef } from 'react';
import classes from './BookExplorationMobile.module.css';
import Svg1 from '../SVG/Svg1';
import Svg2 from '../SVG/Svg2';
import Svg3 from '../SVG/Svg3';

const BookExplorationMobile = (props) => {

  const data = [
    {
      svg: <Svg1 />,
      heading: "Select Your Exploration",
      subHeading: "Choose your adventure from our curated selection, fill out the simple booking form, and let our team guide you through the rest"
    },
    {
      svg: <Svg2 />,
      heading: "Reserve Your Spot",
      subHeading: "Confirm your presence with a deposit. That’s it. Done. You are all set for your adventure"
    },
    {
      svg: <Svg3 />,
      heading: "Arrive at your destination!",
      subHeading: "Get all excited as now you only have to turn up to your destination and make some of the best memories of your life"
    }
  ]

  const [currentStep, setCurrentStep] = useState(0);

  const touchStartX = useRef(null);

  const handleTouchStart = (event) => {
    touchStartX.current = event.touches[0].clientX;

  };

  const handleTouchMove = (event) => {
    if (!touchStartX.current) {
      return;
    }

    const touchEndX = event.touches[0].clientX;
    const swipeDistance = touchEndX - touchStartX.current;
    console.log(Math.abs(swipeDistance))

    if (Math.abs(swipeDistance) > 5) {
      if (swipeDistance > 0) {
        // Swiped right
        setTimeout(() => {
          if (currentStep == 0) setCurrentStep(2);
          else setCurrentStep(currentStep - 1);
        }, 200)
      } else {
        // Swiped left
        setTimeout(() => {
          if (currentStep == 2) setCurrentStep(0);
          else setCurrentStep(currentStep + 1);
        }, 200)
      }
    }

    touchStartX.current = null;
  };

  const handleArrowClickLeft = () => {
    setTimeout(()=> {
      if(currentStep==0)setCurrentStep(2);
      else setCurrentStep(currentStep-1)
    },200)
  }

  const handleArrowClickRight = () => {
    setTimeout(()=> {
      if(currentStep==2)setCurrentStep(0);
      else setCurrentStep(currentStep+1)
    },200)
  }

  return (
    <>
      <div className={classes["book-exploration-mobile-container"]}>
        <div className={classes["swipe-arrow-container"]}>
          {currentStep==0 ?
  <svg onClick={handleArrowClickLeft}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M10 19l-7-7 7-7" />
</svg>
:
<svg onClick={handleArrowClickLeft}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#e65439" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10 19l-7-7 7-7" />
        </svg>
        }
        
        </div>

        <div className={classes["sub-container"]} onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={() => (touchStartX.current = null)}>
          {data[currentStep]?.svg}
          <p className={classes["heading"]}>{data[currentStep]?.heading}</p>
          <p className={classes["sub-heading"]}>{data[currentStep]?.subHeading}</p>
          <div className={classes['current']}>
            <div onClick={() => { setCurrentStep(0) }} style={{ backgroundColor: `${currentStep == 0 ? '#e65439' : ''}` }} className={classes['circle']}></div>
            <div onClick={() => { setCurrentStep(1) }} style={{ backgroundColor: `${currentStep == 1 ? '#e65439' : ''}` }} className={classes['circle']}></div>
            <div onClick={() => { setCurrentStep(2) }} style={{ backgroundColor: `${currentStep == 2 ? '#e65439' : ''}` }} className={classes['circle']}></div>
          </div>
        </div>
        <div className={classes["swipe-arrow-container"]}>
          {
            currentStep==2?
            <svg onClick={handleArrowClickRight} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 5l7 7-7 7" />
        </svg>
        :
        <svg onClick={handleArrowClickRight} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#e65439" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 5l7 7-7 7" />
        </svg>
          }
        
        </div>
      </div>
    </>
  )
}

export default BookExplorationMobile;